import { render, staticRenderFns } from "./SiteAttendance.vue?vue&type=template&id=45c5e7c9"
import script from "./SiteAttendance.vue?vue&type=script&lang=ts"
export * from "./SiteAttendance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports